var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
export default gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment CAREPLAN_COST_FRAGMENT on BaseCost {\n    copay\n    deductible\n    insurance_copay\n    user_pays\n    total\n  }\n"], ["\n  fragment CAREPLAN_COST_FRAGMENT on BaseCost {\n    copay\n    deductible\n    insurance_copay\n    user_pays\n    total\n  }\n"])));
var templateObject_1;
